import api from "../../../../../api";


export const requestGetUserNewNotifications = (props) => {

    let url = `/notifications/new`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestGetUserOldNotifications = (props) => {

    let url = `/notifications/old`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};


